import { MapAddress } from '@/types/address';

export const getFormatedAddress = (addressData: any) => {
  const ShouldBeComponent: any = {
    street_name: ['route'],
    street_number: ['street_number'],
    zip_code: ['postal_code'],
    street: ['street_address', 'route'],
    city: [
      'locality',
      'sublocality',
      'sublocality_level_1',
      'sublocality_level_2',
      'sublocality_level_3',
      'sublocality_level_4',
    ],
  };

  const address: MapAddress = {
    street_name: null,
    street_number: null,
    house_nuber: null,
    zip_code: null,
    city: null,
    location: {
      lat: addressData?.geometry.location.lat() ?? null,
      lng: addressData?.geometry.location.lng() ?? null,
    },
    formatted_address: addressData.formatted_address,
    place_id: addressData?.place_id,
  };

  addressData.address_components.forEach((component: any) => {
    for (const shouldBe in ShouldBeComponent) {
      if (
        typeof shouldBe == 'string' &&
        ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1
      ) {
        address[shouldBe as keyof MapAddress] = component.long_name;
      }
    }
  });

  return address;
};
